import { render, staticRenderFns } from "./VerificationUpload.vue?vue&type=template&id=0751e7fe&"
import script from "./VerificationUpload.vue?vue&type=script&lang=js&"
export * from "./VerificationUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports